export default "__VITE_ASSET__B5zUmesN__"